import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import points from '../../../../utils/polygonPoints';
import heroImage from '../images/hero-background.jpg';
import './Hero.css';

const Hero = ({ isDesktop, currentPath }) => {
    const imageHeroStyle = {
        backgroundImage: `url(${heroImage})`,
    };
    const color1 = '#26588D';
    const color2 = '#38C2D8';
    const color3 = '#FFF';

    return (
        <div className="hero office-grid-hero" style={imageHeroStyle}>
            <h1 className="hidden">{`${currentPath === '/map' ? 'Map of All of the HPP Properties' : currentPath === '/list' ? 'HPP&apos;s Listed Availabilities' : 'View All the HPP Properties'}`}</h1>
            {isDesktop && <Fragment>
                <div className="svg-triangle">
                    <svg preserveAspectRatio="none" viewBox="0 0 80 100">
                        <polygon className="filled-polygon" points={points.hero.top} opacity=".5"></polygon>
                        <defs>
                            <linearGradient id="light-to-dark-blue">
                                <stop offset="0" stopColor={color1} />
                                <stop offset="1" stopColor={color2} />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div className="svg-triangle">
                    <svg preserveAspectRatio="none" viewBox="0 0 80 100">
                        <polygon points={points.hero.bottom} opacity=".2" fill={color3}></polygon>
                    </svg>
                </div>
            </Fragment>}
            <div className="hero-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-offset-1-desktop is-10-desktop animated fadeInLeft">
                            <div className="pre-title">OFFICE</div>
                            <div className="big-title">Ideally located, custom<br /> designed for innovators and<br /> those who support them</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Hero.propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    currentPath: PropTypes.string.isRequired,
};

export default Hero;
